import {
  type UdpTrackingMetadata,
  type UdpTrackingProductAddToCart,
  type UdpTrackingProductImpression,
  type UdpTrackingRecommendationAddToCartSource,
} from '../model/udpTrackingTypes'
import { udpTrackingDataLayerPushAddToCart } from '../udpTrackingDataLayer'
import { udpTrackingImpressionStorageSave } from '../udpTrackingImpressionStorage'

export const udpTrackingPushRecommendationAddToCart = ({
  addToCartSource,
  buildMetadata,
  impression,
  product,
}: {
  addToCartSource: UdpTrackingRecommendationAddToCartSource
  buildMetadata: () => UdpTrackingMetadata
  impression: UdpTrackingProductImpression
  product: UdpTrackingProductAddToCart
}): void => {
  if (
    impression.impression_origin !== 'recommendation' ||
    !impression.impression_origin_data ||
    !('widget_id' in impression.impression_origin_data)
  ) {
    return
  }

  udpTrackingDataLayerPushAddToCart({
    addToCartSource,
    grossValue: product.quantity * product.price.amount,
    impressionId: impression.impression_id,
    impressionOrigin: impression.impression_origin,
    impressionOriginData: impression.impression_origin_data,
    metadata: buildMetadata(),
    product,
  })

  udpTrackingImpressionStorageSave({
    attributedUpid: product.upid,
    impression,
    impressionOrigin: 'recommendation',
    quantity: product.quantity,
    upid: impression.product.upid,
    widgetId: impression.impression_origin_data.widget_id,
  })
}
